<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Kundenauftrag stornieren
            </modal-header>
            <modal-content>
                <form-input aria-invalid="date" label="Datum" v-model="form.date" :error="form.errors.date"
                            disabled="true"/>
                <form-html id="message_producer"
                           :label="'Nachricht an Produzenten' + this.askForQuote?.producer_order?.producer_user?.company"
                           v-model="form.message_producer" :error="form.errors.message_producer" height="300px"/>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="error" :disabled="form.processing" :class="{'btn--processing': form.processing}">Stornieren</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormHtml from '@partfactory/Shared/Form/FormHtml';

export default {
    name: 'ProducerOrderCancelModal',
    components: {FormHtml, FormInput, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
    },
    emit: ['closeDialog'],
    data() {
        if (this.askForQuote?.producer_order?.producer_user?.language === 2) {
            this.$language.current = 'en';
        } else {
            this.$language.current = 'de';
        }

        const translated_producer = this.$gettext('<h1>Guten Tag %{name},</h1>' +
            '<p>leider müssen wir Ihnen mitteilen, dass Ihr Auftrag %{pfnumber} aus folgendem Grund storniert wurde:</p>' +
            '<p>(Bitte Grund eintragen)</p>' +
            '<p>Wir bedauern diesen Vorgang sehr.</p>' +
            '<p>Beste Grüße,</p>' +
            '<p>%{operator}, Service Operator PART FACTORY</p>');

        const message_producer = this.$gettextInterpolate(translated_producer, {
            name: this.askForQuote?.producer_order?.producer_user?.name,
            pfnumber: this.askForQuote.pfnumber,
            operator: this.$page.props.adminUsers[0].name,
        });

        this.$language.current = 'de';

        const form = useForm({
            date: this.$moment().format('DD.MM.YYYY'),
            message_producer: message_producer,
        });
        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.order-information.producer-order-cancel', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
